// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rA3l","importantInfo":"styles_importantInfo__3x5tZ"};